<div
  class="image-container container center"
  style="background-image: url('/assets/images/about-us/finishes.webp')"
>
</div>

<h1
  class="page-title"
>
  Finisaje
</h1>

<div class="container">
  <p>
    Apartamentele, împărţite modern, construite cu simt de răspundere, sunt predate la cheie, inclusiv cu finisajele exterioare şi interioare, de o calitate superioară, şi beneficiază de toate utilităţile necesare (apă, canalizare, gaz, curent electric, etc).
  </p>
  <label class="subtitle">
    Tu îți personalizezi locuința
  </label>
  <p>
    Casa este sanctuarul tău, iar noi știm asta. De aceea, te ajută m
    să-ți personalizezi locuința prin alegerea finisajelor pe care ți le
    punem la dispoziție. Nu îți face griji, avem o paletă largă. Suntem
    siguri că vei găsi ceva pe gustul tău.
    Noi dăm viață visului tău, rămâne la latitudinea ta modul în care
    scrii povestea casei tale.
  </p>
</div>



// WEBPACK FOOTER //
// ./src/app/about-us/finishes.component.html